import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll to top on every client-side route change.
 *
 * Layout effect in the browser so SPA navigations don't flash the previous
 * scroll position. `useEffect` on the server — `useLayoutEffect` is a no-op
 * during prerender and React warns if it is called there.
 */
const useIsoLayoutEffect = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

export default function ScrollToTop() {
    const { pathname } = useLocation();
    useIsoLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}
